import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/i18n';
import { CategoryTreeContainer } from '../../state/categories';
import { house, Icon } from '../Icon/Icon';
import './Breadcrumbs.css';

type BreadcrumbsProps = { perma: string };
export function Breadcrumbs({ perma }: BreadcrumbsProps) {
	const { getBreadcrumbs } = CategoryTreeContainer.useContainer();
	const path = getBreadcrumbs(perma);

	/*
	 * Every separator is an element rather than loose text. A browser translating the page swaps
	 * text nodes for elements of its own, and react removing a text node it no longer finds where
	 * it left it throws - which took the whole page down through the error boundary on the first
	 * click from one category to the next. The words themselves are still translated.
	 */
	return (
		<div className="breadcrumbs">
			<Link to="/">
				<Icon shape={house} size={14} />
			</Link>
			<span className="crumb-separator"> / </span>
			{path.map((e, i) => (
				<Fragment key={e.id}>
					{i ? <span className="crumb-separator"> / </span> : null}
					<Link className={i === path.length - 1 ? 'last-crumb' : ''} to={'/' + e.perma}>
						{e.name}
					</Link>
				</Fragment>
			))}
		</div>
	);
}

export function BrandBreadcrumbs({ slug, name }: { slug: string; name: string }) {
	const tBrand = useTranslation().brand;
	const tRoutes = useTranslation().routes;

	return (
		<div className="breadcrumbs">
			<Link to="/">
				<Icon shape={house} size={14} />
			</Link>{' '}
			/ <Link to={tRoutes.brands}>{tBrand.brands}</Link>/{' '}
			<Link className="last-crumb" to={`${tRoutes.brands}/${slug}`}>
				{name}
			</Link>
		</div>
	);
}
